import { call, put } from "redux-saga/effects";
import {fetchScanDetailsData, fetchShipmentData} from "../api/scanDetailsDataApi";
import { errorRetrievingScanDetailsData, noResultsScanDetailsData, receiveScanDetailsData } from "../actions/scanDetailsDataActions";
import {receiveShipmentDetailsData} from "../actions/shipmentDetailsDataActions";


// worker Saga: will be fired on USER_FETCH_REQUESTED actions
export default function* getScanDetailsData(action) {
  try {
    // do api call
    const data = yield call(fetchScanDetailsData, action.payload);

    if (data.length === 0) {
      yield put(noResultsScanDetailsData());
    } else {
      yield put(receiveScanDetailsData(data));
    }

  } catch (e) {
    console.log("ERROR");
    yield put(errorRetrievingScanDetailsData(e.message));
  }
}

export function* getShipmentDetailsData(action) {
    try {
        const data = yield call(fetchShipmentData, action.payload);
        //TODO Need to handle error better
        if(data === undefined)
            return;
        if( data.length > 0) {
            yield put(receiveShipmentDetailsData(data[0]));
        }
        //ToDO Need to figure out how to handle if a tracking Id was not found
    }
    catch (e) {
        console.log(e);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/scanDetailsSaga.js